"use client";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import React, { Fragment, useEffect, useState } from "react";
var regex = /(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?/gm;
export var extractUrl = function(input) {
    regex.lastIndex = 0;
    var match = regex.exec(input);
    return match === null || match === void 0 ? void 0 : match.shift();
};
export var parseYoutubeId = function(input) {
    var url = extractUrl(input);
    if (!url) {
        return undefined;
    }
    var parts = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    return parts[2] !== undefined ? parts[2].split(/[^0-9a-z_-]/i)[0] : undefined;
};
export default function VideoModalButton(param) {
    var label = param.label, target = param.target, buttonClasses = param.buttonClasses, arrowDisplay = param.arrowDisplay;
    var closeModal = function closeModal() {
        setIsModalOpen(false);
    };
    var openModal = function openModal() {
        setIsModalOpen(true);
    };
    var _useState = _sliced_to_array(useState(target), 2), videoTarget = _useState[0], setVideoTarget = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isModalOpen = _useState1[0], setIsModalOpen = _useState1[1];
    useEffect(function() {
        if (target.toLowerCase().includes("youtube.com/watch") || target.toLowerCase().includes("youtu.be")) {
            var id = parseYoutubeId(target);
            if (id) {
                setVideoTarget("https://www.youtube.com/embed/".concat(id));
            }
        }
    }, [
        target
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("button", {
        onClick: openModal,
        className: buttonClasses
    }, arrowDisplay ? /*#__PURE__*/ React.createElement("div", {
        className: "group inline-flex items-center text-sm font-heading font-semibold focus"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "mr-1"
    }, label), /*#__PURE__*/ React.createElement("svg", {
        width: "15px",
        height: "12px",
        viewBox: "0 0 15 12",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        className: "ml-1.5 relative text-black left-0 group-hover:left-1 group-hover:text-blue-500 transition-all"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Homepage",
        transform: "translate(-460.000000, -5707.000000)",
        stroke: "currentColor",
        strokeWidth: "1.5"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Case-Studies",
        transform: "translate(75.000000, 5059.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Industry/Featured",
        transform: "translate(0.000000, 284.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Link-Tab",
        transform: "translate(268.000000, 340.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Link/Learn/Static",
        transform: "translate(40.000000, 23.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Icon/Arrow/Small",
        transform: "translate(77.000000, 0.000000)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M8.51677215,2.05025253 L13.5057818,7 L8.51677215,11.9497475 M13.5057818,7 L0.805836652,7",
        id: "Icon"
    })))))))))) : /*#__PURE__*/ React.createElement("span", null, label !== null && label !== void 0 ? label : "")), /*#__PURE__*/ React.createElement(Transition, {
        appear: true,
        show: isModalOpen,
        as: Fragment
    }, /*#__PURE__*/ React.createElement(Dialog, {
        as: "div",
        className: "relative z-50",
        onClose: closeModal,
        "aria-label": "Video modal"
    }, /*#__PURE__*/ React.createElement(Transition.Child, {
        as: Fragment,
        enter: "ease-out duration-300",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "ease-in duration-200",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "fixed inset-0 bg-black bg-opacity-75"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "fixed inset-0 overflow-y-auto"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex min-h-full items-center justify-center p-4 text-center"
    }, /*#__PURE__*/ React.createElement(Transition.Child, {
        as: Fragment,
        enter: "ease-out duration-300",
        enterFrom: "opacity-0 scale-95",
        enterTo: "opacity-100 scale-100",
        leave: "ease-in duration-200",
        leaveFrom: "opacity-100 scale-100",
        leaveTo: "opacity-0 scale-95"
    }, /*#__PURE__*/ React.createElement(Dialog.Panel, {
        className: "w-full max-w-3xl relative text-left align-middle transition-all"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mt-2"
    }, /*#__PURE__*/ React.createElement("iframe", {
        width: "717",
        height: "403",
        src: "".concat(videoTarget, "?autoplay=1"),
        title: "YouTube video player",
        allow: "autoplay; encrypted-media",
        allowFullScreen: true,
        className: "max-w-full"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "mt-4"
    }, /*#__PURE__*/ React.createElement("button", {
        type: "button",
        onClick: closeModal,
        className: "text-white absolute -top-10 md:-top-8 right-0 md:-right-4",
        "aria-label": "Close video modaal"
    }, /*#__PURE__*/ React.createElement(XMarkIcon, {
        className: "w-8 h-8"
    }))))))))));
}
